import React from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Features } from './components/Features';
import { Creators } from './components/Creators';
import { Tournaments } from './components/Tournaments';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-neutral-950 text-white selection:bg-red-600 selection:text-white font-sans" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problems data-id="element-3" />
        <Features data-id="element-4" />
        <Creators data-id="element-5" />
        <Tournaments data-id="element-6" />
        <Pricing data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}